import { render, staticRenderFns } from "./LiveRoomList.vue?vue&type=template&id=42e20865&scoped=true&"
import script from "./LiveRoomList.vue?vue&type=script&lang=js&"
export * from "./LiveRoomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e20865",
  null
  
)

export default component.exports